import {Title} from '@management-ui/core';
import {Paper} from '@mui/material';
import {styled} from '@mui/styles';
import moment from 'moment';
import * as React from 'react';
import {useContext, useMemo, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import routes from '../../../../routes';
import Contacts from './Contacts';
import Orders from './Orders';
import WeekSelector from './WeekSelector';

const Heading = styled('h3')(({theme}) => ({
  fontSize: '1.6em',
  margin: theme.spacing(4, 0, 0),
  padding: theme.spacing(0, 3),
}));

const Holder = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    marginTop: theme.spacing(2),
    overflow: 'hidden',
  }
}));

const Dashboard = () => {
  const services = useContext(ServiceContext);
  const [week, setWeek] = useState(moment().startOf('isoWeek'));

  const range = useMemo(() => ({
    from: week.clone().startOf('isoWeek').format('YYYY-MM-DD'),
    to: week.clone().endOf('isoWeek').format('YYYY-MM-DD'),
  }), [week]);

  return (
    <>
      <Title title="Dashboard"/>
      <Heading>Pending Collections</Heading>
      <Holder>
        <WeekSelector week={week} onSelectWeek={setWeek}/>
      </Holder>
      <Holder>
        <Orders
          title="Purchase Orders"
          tooltip="There are purchase orders are due to be collected in the given week."
          columnSet="purchase"
          service={services.purchaseOrder}
          filter={{collection: range}}
          baseRoute={routes.purchaseOrders.detail}
          archiveRoute={routes.archive.purchaseOrder.detail}
        />
      </Holder>
      <Holder>
        <Orders
          title="Sales Orders"
          tooltip="There are sales orders are due to be collected in the given week."
          columnSet="sales"
          service={services.salesOrder}
          filter={{loading: range}}
          baseRoute={routes.salesOrders.detail}
          archiveRoute={routes.archive.salesOrder.detail}
        />
      </Holder>
      <Heading>Outstanding Orders</Heading>
      <Holder>
        <Orders
          title="Purchase Orders"
          tooltip="There are purchase orders which have been marked as delivered but haven't been marked as invoiced. This list only contains orders which were delivered more than 2 days ago."
          columnSet="purchase"
          service={services.purchaseOrder}
          filter={{outstanding: '1'}}
          baseRoute={routes.purchaseOrders.detail}
          archiveRoute={routes.archive.purchaseOrder.detail}
        />
      </Holder>
      <Holder>
        <Orders
          title="Sales Orders"
          tooltip="There are sales orders which have been marked as delivered but haven't been marked as invoiced. This list only contains orders which were delivered more than 2 days ago."
          columnSet="sales"
          service={services.salesOrder}
          filter={{outstanding: '1'}}
          baseRoute={routes.salesOrders.detail}
          archiveRoute={routes.archive.salesOrder.detail}
        />
      </Holder>
      <Heading>Inactive Contacts</Heading>
      <Holder>
        <Contacts title="Suppliers" type="purchase"/>
      </Holder>
      <Holder>
        <Contacts title="Customers" type="sale"/>
      </Holder>
    </>
  );
}

export default Dashboard;
